import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import * as dateHolidays from 'date-holidays';
import { GlobalDataService } from '@providers/global-data/global-data.service';
import { RequestService } from '@providers/request/request.service';
import { RequestV2Service } from '@providers/request-service-v2/request-v2.service';
import * as Moment from 'moment';
import { extendMoment } from 'moment-range';
Moment.locale('fr');
var moment = extendMoment(Moment);
var ScheduleComponent = /** @class */ (function () {
    function ScheduleComponent(globalDataService, requestService, requestV2Service) {
        this.globalDataService = globalDataService;
        this.requestService = requestService;
        this.requestV2Service = requestV2Service;
        this.startDate = '';
        this.endDate = '';
        this.expectedEnd = '';
        this.adjustedEnd = '';
        this.progress = 'compliant';
        this.objectKeys = Object.keys;
        this.planning = {};
        this.owner = null;
        this.progressNumber = 0;
        this.holidays = [];
    }
    ScheduleComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.projectObserver = this.globalDataService
                    .getCurrentProject()
                    .subscribe(function (project) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var hd, holidays, apiPlanningResults, apiPlanning;
                    var _this = this;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (project == null || this.currentProject) {
                                    return [2 /*return*/];
                                }
                                hd = new dateHolidays();
                                hd.init('FR');
                                holidays = [];
                                holidays = holidays.concat(hd.getHolidays(moment().weekYear()));
                                holidays = holidays.concat(hd.getHolidays(moment().add('year', 1).weekYear()));
                                this.holidays = holidays.map(function (d) { return moment(d.start); });
                                this.currentProject = project;
                                if (project._planning) {
                                    this.progressNumber = 0;
                                }
                                this.startDate = project.dates.start;
                                this.endDate = project.dates.end;
                                this.expectedEnd = project.dates.expected_end;
                                this.adjustedEnd = project.dates.adjusted_end;
                                this.progress = project.progress;
                                this.owner = this.globalDataService.user;
                                return [4 /*yield*/, this.requestV2Service
                                        .getPlannings(project.id, false, true)];
                            case 1:
                                apiPlanningResults = _a.sent();
                                apiPlanning = apiPlanningResults.items[0];
                                this.apiPlanning = apiPlanning;
                                if (this.apiPlanning && this.apiPlanning._related) {
                                    apiPlanning._related.items.sort(function (a, b) {
                                        var aDate = new Date(a.start_date).getTime();
                                        var bDate = new Date(b.start_date).getTime();
                                        if (aDate < bDate) {
                                            return -1;
                                        }
                                        if (aDate === bDate) {
                                            return 0;
                                        }
                                        return 1;
                                    });
                                    apiPlanning._related.items = apiPlanning._related.items.map(function (item) {
                                        if (item.type !== 'milestone' && item.type !== 'task') {
                                            return null;
                                        }
                                        // Progress
                                        item.progress = Math.round(item.progress * 100);
                                        // Dates
                                        var date = new Date(item.start_date);
                                        item.end_date = _this.calculEndDate(item.start_date, item.duration);
                                        var month = date.getMonth();
                                        var year = date.getFullYear();
                                        // Time state
                                        if (item.type === 'milestone') {
                                            if (date.getTime() <= new Date().getTime()) {
                                                item.timeState = 'PAST';
                                            }
                                            else {
                                                item.timeState = 'FUTURE';
                                            }
                                        }
                                        else {
                                            if (new Date().getTime() > item.end_date.getTime()) {
                                                item.timeState = 'PAST';
                                            }
                                            else if (new Date().getTime() < date.getTime()) {
                                                item.timeState = 'FUTURE';
                                            }
                                            else {
                                                item.timeState = 'ONGOING';
                                                item.leftDays = Math.round(Math.abs((new Date().getTime() - item.end_date.getTime())
                                                    / (24 * 60 * 60 * 1000)));
                                            }
                                        }
                                        // IsCompleted
                                        if (item.type === 'milestone') {
                                            item.isCompleted = item.timeState === 'PAST';
                                        }
                                        else {
                                            item.isCompleted = item.progress === 100;
                                        }
                                        var dateB = moment(new Date(year, month, 0, 0, 0, 0, 0))
                                            .add('1', 'month').toISOString();
                                        if (_this.planning[dateB]) {
                                            item.isFirst = false;
                                            var date_1 = moment(new Date(year, month, 0, 0, 0, 0, 0))
                                                .add('1', 'month').toISOString();
                                            _this.planning[date_1].push(item);
                                        }
                                        else {
                                            item.isFirst = true;
                                            var date_2 = moment(new Date(year, month, 0, 0, 0, 0, 0))
                                                .add('1', 'month').toISOString();
                                            _this.planning[date_2] = [item];
                                        }
                                        return item;
                                    }).filter(function (i) { return i; });
                                }
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    ScheduleComponent.prototype.calculEndDate = function (start, duration) {
        var workedDays = 1;
        var curDate = moment(start);
        while (workedDays < duration) {
            if (curDate.isoWeekday() < 6
                && !this.holidays.find(function (hd) { return hd.isSame(curDate); })) {
                workedDays = workedDays + 1;
            }
            curDate.add(1, 'day');
        }
        return curDate.toDate();
    };
    ScheduleComponent.prototype.ngOnDestroy = function () {
        this.projectObserver.unsubscribe();
    };
    return ScheduleComponent;
}());
export { ScheduleComponent };
